/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RangeValue {
    getFixupPrototypeFunction() { return RangeValue.fixupPrototype; }

    static newInstance(model: Partial<RangeValue>): RangeValue {
        let obj = Object.assign(new RangeValue(), model);
        RangeValue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RangeValue>): RangeValue {
        if (!model) return null;
        return RangeValue.newInstance(<RangeValue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RangeValue) {
        if (!obj) return;

        models.RangeValue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RangeValue): boolean {
        Object.setPrototypeOf(obj, RangeValue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.range) {
            models.FromToValue.fixupPrototype(this.range);
        }
    }

    /**
     * Range value
     */
    range: models.FromToValue;

}
